import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  box: {
    ...dFlex(),
    position: 'relative',
    height: 250,

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      height: 180,
    },
  },
  btn: {
    position: 'absolute',
    left: 0,
    top: -26,
  },
}));

export default useStyles;
